import area from './area';
import auth from './auth';
import product from './product';
import app from './app';
import meta from './meta';
import order from './order';
import reseller from './reseller';
import tradeup from './tradeup';
import search from './search';
import abtest from './abtest';
import paymentStore from './paymentStore';
import { initializeClientStore, initializeServerStore } from './handler';
import { configure } from 'mobx';

// 只有action内可以修改observable数据
configure({ enforceActions: 'always' });

export function rootStoreHandle({ initialState }) {
  const stores = {
    area,
    app,
    reseller,
    auth,
    product,
    meta,
    order,
    tradeup,
    search,
    abtest,
    paymentStore,
  };

  // 服务端渲染
  if (typeof window === 'undefined') {
    return initializeServerStore(stores, initialState);
  }

  // 客户端渲染
  for (const key in stores) {
    stores[key] = initializeClientStore(
      key,
      stores[key],
      initialState && initialState[key] ? initialState[key] : undefined
    );
  }
  return stores;
}
